export default "__VITE_ASSET__BeHcUnui__";